import React, { useState } from 'react';
import axios from 'axios';

const OTPForm = ({ setVerified }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [verified, setVerifiedState] = useState(false); // State to handle OTP verification status

  // Send OTP
  const handleSendOTP = async () => {
    let formattedPhoneNumber = phoneNumber;

    // Automatically prepend +91 if not present
    if (!formattedPhoneNumber.startsWith('+91')) {
      formattedPhoneNumber = `+91${phoneNumber}`;
    }

    try {
      const response = await axios.post(' https://b19a-175-101-108-85.ngrok-free.app/api/send-otp', { phoneNumber: formattedPhoneNumber });
      setMessage(response.data.message);
      setOtpSent(true);
    } catch (error) {
      setMessage(error.response ? error.response.data.error : 'Error sending OTP');
    }
  };

 // Verify OTP
const handleVerifyOTP = async () => {
  let formattedPhoneNumber = phoneNumber;

  // Automatically prepend +91 if not present
  if (!formattedPhoneNumber.startsWith('+91')) {
    formattedPhoneNumber = `+91${phoneNumber}`;
  }

  try {
    const response = await axios.post('http://localhost:5000/api/verify-otp', { phoneNumber: formattedPhoneNumber, otp });
    console.log('Verify OTP Response:', response.data);  // Log response data
    if (response.data.verified) {
      setVerified(true);  // Set verified status to true
      setVerifiedState(true); // Set the state as verified
    }
    setMessage(response.data.message);
  } catch (error) {
    console.error('Error verifying OTP:', error);  // Log error details
    setMessage(error.response ? error.response.data.error : 'Error verifying OTP');
  }
};


  // Mock Scanner Component (replace with actual QR scanner or UPI code)
  const QRCodeScanner = () => (
    <div>
      <h3>UPI QR Code Scanner</h3>
      <img src="your-upi-qr-code-image.png" alt="UPI QR Code" />
      <p>Scan this QR code to proceed with the payment.</p>
    </div>
  );

  return (
    <div>
      <h2>OTP Verification</h2>
      
      {/* If not verified, show OTP input */}
      {!verified ? (
        <div>
          {!otpSent ? (
            <div>
              <input
                type="text"
                placeholder="Enter mobile number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
              <button 
                className='text-white bg-[#225B4B] md:px-4 py-2 w-44 rounded-lg font-serif m-8' 
                onClick={handleSendOTP}>
                Send OTP
              </button>
            </div>
          ) : (
            <div>
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
              <button onClick={handleVerifyOTP}>Verify OTP</button>
            </div>
          )}
        </div>
      ) : (


        <div className="flex justify-center items-center ">
        <div className="text-center">
          <h2 className="mt-6 text-4xl">QR Code</h2>
          <img src="images/upi.png" alt="QR Code" className="mx-auto " />
        </div>
      </div>
      )}

      {/* Display any messages */}
      {message && <p>{message}</p>}
    </div>
  );
};

export default OTPForm;
